var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendSqaure2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5866 2.66663H10.4133C5.55996 2.66663 2.66663 5.55997 2.66663 10.4133V21.5734C2.66663 26.4401 5.55996 29.3334 10.4133 29.3334H21.5733C26.4266 29.3334 29.32 26.4401 29.32 21.5867V10.4133C29.3333 5.55997 26.44 2.66663 21.5866 2.66663ZM11.52 17.08L17.36 11.24H14.12C13.5733 11.24 13.12 10.7867 13.12 10.24C13.12 9.69332 13.5733 9.23998 14.12 9.23998H19.7733C19.9066 9.23998 20.0266 9.26665 20.16 9.31998C20.4 9.42665 20.6 9.61332 20.7066 9.86665C20.76 9.98665 20.7866 10.12 20.7866 10.2533V15.9067C20.7866 16.4533 20.3333 16.9067 19.7866 16.9067C19.24 16.9067 18.7866 16.4533 18.7866 15.9067V12.6667L12.9333 18.4934C12.7333 18.6934 12.48 18.7867 12.2266 18.7867C11.9733 18.7867 11.72 18.6934 11.52 18.4934C11.1333 18.1067 11.1333 17.4667 11.52 17.08ZM24.32 22.96C21.64 23.8534 18.8266 24.3067 16 24.3067C13.1733 24.3067 10.36 23.8534 7.67996 22.96C7.15996 22.7867 6.87996 22.2134 7.05329 21.6934C7.22663 21.1734 7.78663 20.88 8.31996 21.0667C13.28 22.72 18.7333 22.72 23.6933 21.0667C24.2133 20.8934 24.7866 21.1734 24.96 21.6934C25.12 22.2267 24.84 22.7867 24.32 22.96Z",
    fill: "#7D14FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5866 2.66663H10.4133C5.55996 2.66663 2.66663 5.55997 2.66663 10.4133V21.5734C2.66663 26.4401 5.55996 29.3334 10.4133 29.3334H21.5733C26.4266 29.3334 29.32 26.4401 29.32 21.5867V10.4133C29.3333 5.55997 26.44 2.66663 21.5866 2.66663ZM11.52 17.08L17.36 11.24H14.12C13.5733 11.24 13.12 10.7867 13.12 10.24C13.12 9.69332 13.5733 9.23998 14.12 9.23998H19.7733C19.9066 9.23998 20.0266 9.26665 20.16 9.31998C20.4 9.42665 20.6 9.61332 20.7066 9.86665C20.76 9.98665 20.7866 10.12 20.7866 10.2533V15.9067C20.7866 16.4533 20.3333 16.9067 19.7866 16.9067C19.24 16.9067 18.7866 16.4533 18.7866 15.9067V12.6667L12.9333 18.4934C12.7333 18.6934 12.48 18.7867 12.2266 18.7867C11.9733 18.7867 11.72 18.6934 11.52 18.4934C11.1333 18.1067 11.1333 17.4667 11.52 17.08ZM24.32 22.96C21.64 23.8534 18.8266 24.3067 16 24.3067C13.1733 24.3067 10.36 23.8534 7.67996 22.96C7.15996 22.7867 6.87996 22.2134 7.05329 21.6934C7.22663 21.1734 7.78663 20.88 8.31996 21.0667C13.28 22.72 18.7333 22.72 23.6933 21.0667C24.2133 20.8934 24.7866 21.1734 24.96 21.6934C25.12 22.2267 24.84 22.7867 24.32 22.96Z",
    fill: "url(#paint0_linear_2946_45071)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2946_45071",
    x1: 2.66663,
    y1: 2.66663,
    x2: 29.3334,
    y2: 29.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#873BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A173FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7D14FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#873BFF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F00FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSqaure2);
export default __webpack_public_path__ + "static/media/send-sqaure-2.32a392d8849c55befe6df7b4cf5d2279.svg";
export { ForwardRef as ReactComponent };